import {
    AddIcon,
    Button,
    Flex,
    Image,
    Table,
    Text,
} from "@fluentui/react-northstar";
import React from "react";
import styled, { css } from "styled-components";
import {
    COLOR_GRADIENT_VIOLET,
    COLUMNS_SIZE,
    I18N_NS_EXPENSE,
} from "../../../constants";
import BadgeCounterCommentaire from "../../Badges/BadgeCounterCommentaire";
import moment from "moment";
import RowEmpty from "../Row";
import BadgeTvaPercentage from "../../Badges/BadgeTvaPercentage";
import {
    currency_code_to_symbols,
    format_number,
} from "../../../../../constants/maths";
import { Date, MoreItem } from "../RowsExpenseDetail";
import { Title } from "./RowExpense";
import {
    ReceiptAdd24Regular,
    PanelRightRegular,
    PanelRightFilled,
} from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import TVARate from "../../Cards/TVARate";
import { LEVELS, LEVELS_BACKEND } from "../../Badges/Status";
import { get_symbol_currency } from "../../../functions";
import { DEVICE, SIZES } from "../../../../../constants/responsive";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

const TableRowExpense = ({
    LENGTH_EXPENSES = 0,
    REPORT_STATUS,
    IS_CAN_SEND,
    isMobile,
    detail,
    id_report,
    refetch_get_all_expenses,
    selectedExpense,
    disableMoreItem = false,
    onClickTitle = () => null,
    handle_click_comment = () => null,
    on_click_view_document = () => null,
    goto_add_category = () => null,
}) => {
    const location = useLocation();
    const isOnPageAccountingManager =
        location.pathname.includes("accounting_manager");

    const { t } = useTranslation(I18N_NS_EXPENSE);

    const isLessThenTablet = useMediaQuery({
        query: `(max-width: ${SIZES.tablet})`,
    });

    const handleClickCommentButton = (e, i) => {
        e.stopPropagation();
        e.preventDefault();
        const { data_expense } = i;
        handle_click_comment(data_expense);
        on_click_view_document(data_expense?.documents.at(0)?.attached_doc);
        return;
    };

    const isDraft = REPORT_STATUS === 0; // brouillon
    const IS_STATUS_RECOGNISED =
        LEVELS_BACKEND[REPORT_STATUS] === LEVELS.recognised;
    const REFUND_AMOUNT =
        LEVELS_BACKEND[REPORT_STATUS] === LEVELS.refuse
            ? "0,00"
            : format_number(detail?.expense_report?.amount_approved);

    const COLOR_REFUND_TEXT =
        LEVELS_BACKEND[REPORT_STATUS] === LEVELS.refuse
            ? "var(--color-danger)"
            : LEVELS_BACKEND[REPORT_STATUS] === LEVELS.approuve
            ? "var(--color-success)"
            : IS_STATUS_RECOGNISED
            ? "var(--color-success)"
            : "#242424";

    const cell_styles = {
        more: {
            flexGrow: "0",
            flexBasis: "50px",
            padding: 0,
            ["@media " + DEVICE.mobileS]: {
                flexBasis: "30px",
            },
            ["@media " + DEVICE.laptop]: {
                flexBasis: "50px",
            },
        },
    };

    return (
        <Body column gap="gap.medium">
            <STable aria-label="table" styles={{ width: "100%" }}>
                <STableRow header>
                    <Cell
                        $start
                        $minWidth={COLUMNS_SIZE.name}
                        content={
                            <SFirstColumnText content="Liste des dépenses" />
                        }
                    />
                    {!isLessThenTablet && (
                        <Cell
                            content={<SColumnsHead content="" />}
                            $minWidth={COLUMNS_SIZE.percent}
                        />
                    )}
                    {!isLessThenTablet && (
                        <Cell
                            content={<SColumnsHead content="HT" />}
                            $minWidth={COLUMNS_SIZE.ht}
                        />
                    )}
                    {!isLessThenTablet && (
                        <Cell
                            content={<SColumnsHead content="TVA" />}
                            $minWidth={COLUMNS_SIZE.tva}
                        />
                    )}
                    <Cell
                        content={<SColumnsHead content="TTC" />}
                        $minWidth={COLUMNS_SIZE.ttc}
                    />
                    <Cell
                        content=""
                        $minWidth={COLUMNS_SIZE.more}
                        styles={cell_styles.more}
                    />
                    {!isLessThenTablet && (
                        <Cell
                            content=""
                            $minWidth={COLUMNS_SIZE.icon}
                            styles={{
                                flexGrow: "0",
                                flexBasis: "40px",
                                padding: 0,
                            }}
                        />
                    )}
                </STableRow>
                {LENGTH_EXPENSES === 0 ? (
                    <RowEmpty />
                ) : (
                    detail?.expense_report?.expenses?.map((expense, index) => {
                        const count_messages = expense?.history?.length;
                        const is_km_form =
                            expense?.category?.form_type === "km_fr" ||
                            expense?.category?.form_type === "km_ch";

                        const HT = currency_code_to_symbols({
                            amount:
                                expense?.declared_amount -
                                expense?.vats?.at(0)?.declared_amount,
                            currency: expense?.currency,
                        });

                        const TVA = is_km_form
                            ? expense?.bareme
                            : currency_code_to_symbols({
                                  amount: expense?.vats?.at(0)?.declared_amount,
                                  currency: expense?.currency,
                              });

                        const TTC = currency_code_to_symbols({
                            amount: expense?.declared_amount,
                            currency: expense?.currency,
                        });

                        return (
                            <SRows key={"expense_" + index}>
                                <Cell
                                    $start
                                    $minWidth={COLUMNS_SIZE.name}
                                    content={
                                        <Flex vAlign="center" gap="gap.small">
                                            <Date>
                                                {moment(expense.date).format(
                                                    "DD/MM"
                                                )}
                                            </Date>
                                            <Flex
                                                gap="gap.small"
                                                styles={{
                                                    width: "100%",
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onClickTitle({
                                                        id_expense: expense?.id,
                                                        id_report: id_report,
                                                        form_type:
                                                            expense?.category
                                                                ?.form_type,
                                                    });
                                                    return;
                                                }}
                                            >
                                                <Flex gap="gap.small">
                                                    <Image
                                                        src={
                                                            expense?.category
                                                                ?.icon_url
                                                        }
                                                        width="20px"
                                                    />
                                                    <Title
                                                        truncated
                                                        isCursorPointer={
                                                            !disableMoreItem
                                                        }
                                                    >
                                                        {expense?.name}
                                                    </Title>
                                                </Flex>
                                                {!isMobile && (
                                                    <BadgeCounterCommentaire
                                                        count={count_messages}
                                                    />
                                                )}
                                            </Flex>
                                        </Flex>
                                    }
                                />
                                {!isLessThenTablet && (
                                    <Cell
                                        content={
                                            <SColumnsHead
                                                content={
                                                    <BadgeTvaPercentage
                                                        rate={
                                                            is_km_form
                                                                ? "0%"
                                                                : expense?.vats?.at(
                                                                      0
                                                                  )?.value ===
                                                                  -1
                                                                ? "Autre"
                                                                : expense?.vats?.at(
                                                                      0
                                                                  )?.value + "%"
                                                        }
                                                    />
                                                }
                                            />
                                        }
                                        $minWidth={COLUMNS_SIZE.percent}
                                    />
                                )}
                                {!isLessThenTablet && (
                                    <Cell
                                        content={
                                            <SColumnsHead
                                                content={
                                                    <CellText content={HT} />
                                                }
                                            />
                                        }
                                        $minWidth={COLUMNS_SIZE.ht}
                                    />
                                )}
                                {!isLessThenTablet && (
                                    <Cell
                                        content={
                                            <SColumnsHead
                                                content={
                                                    <CellText content={TVA} />
                                                }
                                            />
                                        }
                                        $minWidth={COLUMNS_SIZE.tva}
                                    />
                                )}
                                <Cell
                                    content={
                                        <SColumnsHead
                                            content={
                                                <CellText
                                                    weight="bold"
                                                    content={TTC}
                                                />
                                            }
                                        />
                                    }
                                    $minWidth={COLUMNS_SIZE.ttc}
                                />
                                <Cell
                                    content={
                                        <Flex hAlign="end">
                                            <MoreItem
                                                key={"moteItem"}
                                                id_expense={expense?.id}
                                                disabled={disableMoreItem}
                                                refetch_get_all_expenses={
                                                    refetch_get_all_expenses
                                                }
                                                onClickUpdate={(e) => {
                                                    onClickTitle({
                                                        id_expense: expense?.id,
                                                        id_report: id_report,
                                                        form_type:
                                                            expense?.category
                                                                ?.form_type,
                                                    });
                                                }}
                                                hide_delete_button={
                                                    !IS_CAN_SEND
                                                }
                                            />
                                        </Flex>
                                    }
                                    $minWidth={COLUMNS_SIZE.more}
                                    styles={cell_styles.more}
                                />
                                {!isLessThenTablet && (
                                    <Cell
                                        styles={{
                                            flexGrow: "0",
                                            flexBasis: "40px",
                                            padding: 0,
                                        }}
                                        content={
                                            <SButton
                                                icon={
                                                    selectedExpense ===
                                                    expense.id ? (
                                                        <PanelRightFilled
                                                            cursor="pointer"
                                                            fontSize={32}
                                                            width={150}
                                                        />
                                                    ) : (
                                                        <PanelRightRegular
                                                            cursor="pointer"
                                                            fontSize={32}
                                                        />
                                                    )
                                                }
                                                iconOnly
                                                text
                                                onClick={
                                                    handleClickCommentButton
                                                }
                                                data_expense={expense}
                                                disabled={
                                                    !expense?.comment &&
                                                    !expense?.documents.at(0)
                                                        ?.attached_doc
                                                }
                                            />
                                        }
                                        $minWidth={COLUMNS_SIZE.icon}
                                    />
                                )}
                            </SRows>
                        );
                    })
                )}
            </STable>
            {/* ajouter une dépense */}
            <Flex hAlign="center">
                {isDraft && (
                    <SButtonAddExpense
                        primary
                        text
                        size="small"
                        content={
                            isLessThenTablet
                                ? ""
                                : t("report_detail.link_add_expense")
                        }
                        onClick={goto_add_category}
                        icon={<AddIcon />}
                        iconOnly={isLessThenTablet}
                    />
                )}
            </Flex>
            {/* Footer Detail */}
            <SFooter>
                {!isLessThenTablet && (
                    <Flex
                        wrap
                        gap="gap.medium"
                        fill
                        styles={{
                            height: "fit-content",
                        }}
                    >
                        {detail?.expense_report?.taxes?.map((taxe, index) => {
                            const color =
                                COLOR_GRADIENT_VIOLET[
                                    index % COLOR_GRADIENT_VIOLET.length
                                ];
                            return (
                                <TVARate
                                    total={taxe.amount}
                                    currency={taxe.currency}
                                    rate={taxe.value}
                                    color={color}
                                />
                            );
                        })}
                    </Flex>
                )}
                <Grid>
                    <GridRow hAlign="end">
                        <SummaryTvaTitle content="Total HT" />
                    </GridRow>
                    <GridRow hAlign="end">
                        <SummaryTvaTitle
                            content={
                                format_number(
                                    detail?.expense_report?.amount_excluding_tax
                                ) +
                                " " +
                                detail?.expense_report?.currency
                            }
                            $pdr
                        />
                    </GridRow>
                    <GridRow hAlign="end">
                        <SummaryTvaTitle content="Total TVA" />
                    </GridRow>
                    <GridRow hAlign="end">
                        <SummaryTvaTitle
                            content={
                                format_number(
                                    detail?.expense_report?.tax_total
                                ) +
                                " " +
                                detail?.expense_report?.currency
                            }
                            $pdr
                        />
                    </GridRow>
                    <GridRow hAlign="end" $primary>
                        <SummaryTvaTitle content="Total TTC" weight="bold" />
                    </GridRow>
                    <GridRow $primary hAlign="end">
                        <SummaryTvaTitle
                            content={
                                format_number(
                                    detail?.expense_report?.amount_total
                                ) +
                                " " +
                                detail?.expense_report?.currency
                            }
                            weight="bold"
                            $pdr
                        />
                    </GridRow>
                    {[1].includes(REPORT_STATUS) && (
                        <>
                            <GridRow hAlign="end">
                                <SummaryTvaTitle
                                    content="Remboursement"
                                    $color={COLOR_REFUND_TEXT}
                                />
                            </GridRow>
                            <GridRow hAlign="end">
                                <SummaryTvaTitle
                                    content={
                                        REFUND_AMOUNT +
                                        " " +
                                        detail?.expense_report?.currency
                                    }
                                    weight="bold"
                                    $pdr
                                    $color={COLOR_REFUND_TEXT}
                                />
                            </GridRow>
                        </>
                    )}
                </Grid>
            </SFooter>
        </Body>
    );
};

export default TableRowExpense;

const SButton = styled(Button)`
    > .ui-box {
        width: 20px;
    }
`;

const Grid = styled.div`
    display: grid;

    grid-template-rows: repeat(3, 1fr);
    row-gap: 8px;
    @media ${DEVICE.mobileS} {
        width: 100%;
        grid-template-columns: 1fr 1.5fr;
    }
    @media ${DEVICE.tablet} {
        width: 80%;
        grid-template-columns: repeat(2, 1fr);
    }
`;

const SummaryTvaTitle = styled(Text)`
    color: ${(props) => (props.$color ? props.$color : "#424242")};

    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
    @media ${DEVICE.mobileS} {
        padding-right: ${(props) => (props.$pdr ? "30px" : "0")};
    }
    @media ${DEVICE.tablet} {
        ${({ $pdr }) =>
            $pdr
                ? css`
                      padding-right: 50px;
                  `
                : ""}
    }
`;

const GridRow = styled(Flex)`
    display: flex;
    padding: 8px;
    ${({ $primary }) =>
        $primary
            ? css`
                  background-color: #3d3e78;
                  ${SummaryTvaTitle} {
                      color: white;
                  }
              `
            : ""}

    gap: var(--spacing-xl-32, 32px);
    align-self: stretch;
`;

const Cell = styled(Table.Cell)`
    justify-content: ${(props) => (props.$start ? "flex-start" : "end")};

    ${(props) =>
        props.$start
            ? css`
                  border-left: 4px solid transparent;
              `
            : null};
`;

const SFooter = styled(Flex)`
    gap: 16px;
    align-self: stretch;
    border-top: 1px solid var(--Light-theme-Rest-Border-Default-Border, #d1d1d1);
    border-end-end-radius: 4px;
    overflow: hidden;
    @media ${DEVICE.mobileS} {
        padding: 0;
    }
    @media ${DEVICE.tablet} {
        padding: 10px 0px 0px 24px;
    }
`;

const SButtonAddExpense = styled(Button)`
    display: flex;
    height: 40px;
    padding: 0px 20px;
    /* width: fit-content; */
    border-radius: 8px;
    border: 1px dashed var(--Light-theme-Rest-Border-Brand-Border-1, #9299f7);
    background: var(--Light-theme-Rest-Background-Brand-Background-1, #e8ebfa);

    /* shadow-2 */
    box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
        0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

const CellText = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
`;

const SRows = styled(Table.Row)`
    border-left: 4px solid transparent;
    /* padding-left: 8px; */
    ${({ $selected }) =>
        $selected
            ? css`
                  border-left: 4px solid #9299f7;
                  background: #f5f5f5;
              `
            : ""}
    &:hover {
        border-left: 4px solid #9299f7;
        background: #f5f5f5;
    }
    &:hover .cell_amount {
        color: var(--color-primary);
    }
`;

const SColumnsHead = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);
    text-align: right;

    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    @media ${DEVICE.mobileS} {
        font-size: 14px;
    }
    @media ${DEVICE.tablet} {
        font-size: 12px;
    }
`;

const STableRow = styled(Table.Row)`
    border-radius: 8px 8px 0px 0px;
    background: var(--Light-theme-Rest-Background-Brand-Background-2, #3d3e78);
    :hover {
        background: var(
            --Light-theme-Rest-Background-Brand-Background-2,
            #3d3e78
        );
    }
`;

const SFirstColumnText = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);

    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 133.333% */
    text-wrap: nowrap;
    @media ${DEVICE.mobileS} {
        font-size: 14px;
    }
    @media ${DEVICE.laptop} {
        font-size: 18px;
    }
`;

const STable = styled(Table)`
    overflow: scroll;
    width: 100%;
`;

const Body = styled(Flex)`
    width: 100%;
    height: fit-content;

    background-color: white;
    border-radius: 8px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    margin-bottom: 16px;

    /* shadow-4 */
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);

    @media ${DEVICE.mobileS} {
        max-width: 100%;
        min-width: 100%;
    }
    @media ${DEVICE.laptop} {
        max-width: 850px;
        min-width: 850px;
    }
`;
